angular.module('vehicle-location')
    .component('vehicleLocationPicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<",
            modelType: '<',
            onChange: "&"
        },
        templateUrl: "app/vehicle-location/picker.html",
        controller: function(VehicleLocation) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;

                VehicleLocation.query().$promise.then(items => ctrl.items = items);

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
        }
    })
    .component('vehicleLocationButtons', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            modelType: '<?',
            myLocations: "<?",
            onChange: "&?",
        },
        templateUrl: "app/vehicle-location/buttons.html",
        controller: function(VehicleLocation) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                let promise;
                if(!ctrl.myLocations) {
                    promise = VehicleLocation.query().$promise
                }
                else {
                    promise = VehicleLocation.myLocations().$promise
                }
                promise.then(items => ctrl.items = items);

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => viewValue);
            };

            ctrl.onSelectionChanged = () => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange)) {
                    let $model = ctrl.items.find(item => item.id === ctrl.selected)
                    ctrl.onChange({$item: ctrl.selected, $model: $model});
                }
            };
        }
    })
